module.exports = __webpack_public_path__ + "static/img/7.ed9a30d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/7.png
// module id = V+LB
// module chunks = 0